import { withResetState } from "store/hocs";
import { float2Normalizer, taxIdNormalizer } from "validators";

import { merchantInfoConstants } from "./merchantInfo.constants";

var initialState = {
	loading: false,
	error: null,
	merchantInfo: {},
};

function merchantInfo(state = initialState, action) {
	switch (action.type) {
		case merchantInfoConstants.GET_UNDERWRITING_MERCHANT_INFO_REQUEST:
			return {
				...state,
				loading: true,
				tab: action.tab,
			};
		case merchantInfoConstants.GET_UNDERWRITING_MERCHANT_INFO_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				merchantInfo: {
					...action.merchantInfo,
					reserveAmount: float2Normalizer(
						action.merchantInfo?.reserve_amount,
					),
					fundingHold: float2Normalizer(
						action.merchantInfo?.fundingHold,
					),
					amex_AMV: float2Normalizer(action.merchantInfo?.amex_AMV),
					amex_AVT: float2Normalizer(action.merchantInfo?.amex_AVT),
					amex_HT: float2Normalizer(action.merchantInfo?.amex_HT),
					visaMcDiscover_AMV: float2Normalizer(
						action.merchantInfo?.visaMcDiscover_AMV,
					),
					visaMcDiscover_AVT: float2Normalizer(
						action.merchantInfo?.visaMcDiscover_AVT,
					),
					visaMcDiscover_HT: float2Normalizer(
						action.merchantInfo?.visaMcDiscover_HT,
					),
					isHighRisk: String(action.merchantInfo?.isHighRisk),
					isDailyDiscount: action.merchantInfo?.is_daily_discount,
					taxId: taxIdNormalizer(action.merchantInfo?.taxId),
				},
			};
		case merchantInfoConstants.GET_UNDERWRITING_MERCHANT_INFO_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
			};
		case merchantInfoConstants.SET_MERCHANT_INFO_HIGH_RISK:
			return {
				...state,
				merchantInfo: {
					...state.merchantInfo,
					isHighRisk: String(action.isHighRisk),
				},
			};
		default:
			return state;
	}
}

export default withResetState({
	initialState,
	resetLocalStateType:
		merchantInfoConstants.RESET_UNDERWRITING_MERCHANT_INFO_STATE,
})(merchantInfo);
